import { Injectable } from '@angular/core';
import type { WorkflowSlotSnapshot } from '../models/conversation-state.model';

export interface EducationalGeneratePayload {
  teacherId: number | null;
  schoolId: number | null;
  domainName: string;
  questionContent: string;
  pedagogy: string;
  level: string;
  artifact: string;
  numberOfSuggestions: number;
  country?: string;
  language: string;
  includeLocalContext: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AssistantPayloadBuilderService {
  buildGeneratePayload(
    snapshot: WorkflowSlotSnapshot,
    artifact: string,
    teacherId: number | null,
    schoolId: number | null
  ): EducationalGeneratePayload | null {
    const domain = snapshot.topicDomain?.name?.trim();
    const question = snapshot.learningFocus?.content?.trim();
    const pedagogy = snapshot.pedagogy?.trim();
    const level = snapshot.standardLevel?.trim();
    if (!domain || !question || !pedagogy || !level) {
      return null;
    }
    const country = snapshot.countryRegion?.trim() || 'Global';
    const language =
      typeof window !== 'undefined'
        ? localStorage.getItem('targetedLang') || 'en'
        : 'en';
    return {
      teacherId,
      schoolId,
      domainName: domain,
      questionContent: question,
      pedagogy,
      level,
      artifact,
      numberOfSuggestions: 1,
      country,
      language,
      includeLocalContext: country !== 'Global',
    };
  }
}
